import React from 'react';

import { LazyDCScriptMigrationPage } from '@confluence/dc-script-migration/entry-points/DCScriptMigrationPage.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminDCScriptMigrationRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyDCScriptMigrationPage />;

AdminDCScriptMigrationRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'adminDCScriptMigration' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
